import React, { useState } from "react";
import ConstructionList from "../../Components/ConstructionCompanyItems/ConstructionCompanyList/CCList";

const ConstructionCompany = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [companiesPerPage, setCompaniesPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <main className="full-wraper">
      <div className="main-wraper">
        <div className="container-fluid">
          <div className="main-inner">
            <ConstructionList
              companiesPerPage={companiesPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              setCompaniesPerPage={setCompaniesPerPage}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default ConstructionCompany;
